// Hojas de roles ANTES que cualquier componente: paleta (nivel 1) y roles
// semanticos. Ver src/estilos/semantico.css.
import './estilos/paleta.css';
import './estilos/semantico.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ProveedorDeApariencia } from './diseno/Apariencia';
import { ProveedorDeAvisos } from './diseno/Avisos';
import { MarcaDelConsultorio } from './marca/MarcaDelConsultorio';
import { ProveedorDeSesion } from './sesion/SesionProvider';
import { App } from './App';
import { FronteraDeError } from './diseno/FronteraDeError';

const clienteConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Un expediente clinico no se refresca a la espalda del medico mientras
      // lo esta leyendo.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

/**
 * Enrutador de DATOS con una sola ruta comodin que monta el arbol declarativo
 * de `App`. Las rutas siguen escritas como `<Routes>`; el enrutador de datos
 * hace falta porque `useBlocker` (la guardia de cambios sin guardar) solo
 * funciona dentro de uno.
 */
const enrutador = createBrowserRouter([
  {
    path: '*',
    element: (
      <ProveedorDeAvisos>
        <App />
      </ProveedorDeAvisos>
    ),
    errorElement: <FronteraDeError />,
  },
]);

const contenedor = document.getElementById('raiz');
if (!contenedor) throw new Error('Falta el contenedor #raiz en index.html');

createRoot(contenedor).render(
  <StrictMode>
    <QueryClientProvider client={clienteConsultas}>
      <ProveedorDeSesion>
        {/* La apariencia va por fuera de la marca porque el tema se construye
            con las dos cosas: los colores son del consultorio, el modo claro u
            oscuro es del dispositivo. */}
        <ProveedorDeApariencia>
          <MarcaDelConsultorio>
            {/* Dentro del tema: los avisos se pintan con la paleta del
                consultorio (el proveedor va dentro del enrutador). */}
            <RouterProvider router={enrutador} />
          </MarcaDelConsultorio>
        </ProveedorDeApariencia>
      </ProveedorDeSesion>
    </QueryClientProvider>
  </StrictMode>,
);
